export default {
    to: "/dashboard/focus-areas",
    order: 3,
    icon: "mdi-alpha-f-circle-outline",
    title: "Focus Areas",
    disabled: false,
    value: 0,
    sublinks: [],
}
